// extracted by mini-css-extract-plugin
export default {"CreateQuiz":"UpdateQuiz_CreateQuiz__N3onk"};